export default __webpack_public_path__ + "static/media/bgm.d0a6f5f2.mp3";